<template>
  <div>
    <h3 class="mb-0">
      Solicitud de Muestrario(s)
    </h3>
    <hr class="my-2" />

    <div>
      <div class="text-xs font-weight-bold mb-1">Fecha de llegada ideal *</div>
      <flat-picker
        v-model="form.estimatedDate"
        style="cursor: pointer; outline: none;"
        placeholder="Fecha de llegada ideal"
        class="form-control-sm input-group-alternative datepicker text-xs w-100"
      />
    </div>
    <hr class="my-3" />

    <div v-for="(t, tIndex) in form.types" :key="tIndex" class="mb-2">

      <div class="d-flex align-items-center mb-2 type" style="gap:10px;">
      <div @click="removeType(tIndex)" class="remove-type">
        <i class="fa fa-trash fa-xs"></i>
      </div>
      <div style="width: 220px;" class="mb-2">
        <div class="text-xs font-weight-bold mb-1">
          Tipo *
        </div>
        <multiselect
          v-model="t.type"
          :options="filteredTypes"
          class="small-multiselect"
          placeholder="Tipo"
          :allow-empty="false"
          :show-labels="false"
        />
      </div>
    </div>
      <div style="flex:1; margin-left: 24px;">
        <div v-for="(r, rIndex) in t.reasons" :key="rIndex" class="mb-2">
          <div>
            <div class="d-flex align-items-center mb-2 reason" style="gap:10px;">
              <div @click="removeReason(tIndex, rIndex)" class="remove-reason">
                <i class="fa fa-trash fa-xs"></i>
              </div>
              <div style="width: 130px;" class="">
                <div class="text-xs font-weight-bold mb-1">
                  Motivo *
                </div>
                <multiselect
                  v-model="r.reason"
                  :options="filteredReasons(tIndex)"
                  class="small-multiselect"
                  placeholder="Motivo"
                  :allow-empty="false"
                  :show-labels="false"
                />
              </div>
            </div>
            <div v-if="r.reason" style="margin-left: 24px;">
              <div v-for="(rr, rrIndex) in r.refs" :key="rrIndex" class="mb-2 reference">
                <div class="d-flex align-items-center mb-2" style="gap:10px;">
                  <div @click="removeRef(tIndex, rIndex, rrIndex)" class="remove-reference">
                    <i class="fa fa-trash fa-xs"></i>
                  </div>
                  <div style="flex:1; min-width: 0;">
                    <div class="text-xs font-weight-bold mb-1">
                      {{r.reason}} *
                    </div>
                    <multiselect
                      v-if="r.reason === 'Cliente'"
                      v-model="rr.ref"
                      :options="customers || []"
                      class="small-multiselect"
                      placeholder="Cliente"
                      track-by="CardCode"
                      label="CardName"
                      :allow-empty="false"
                      :show-labels="false"
                      :loading="!customers"
                      :options-limit="30"
                    />
                    <base-input
                      v-else
                      v-model="rr.ref"
                      :placeholder="r.reason"
                      inputClasses="input-group-alternative form-control-sm text-xs"
                      class="m-0"
                    />
                  </div>
                  <div style="width: 90px;">
                    <div class="text-xs font-weight-bold mb-1">
                      Cantidad *
                    </div>
                    <base-input
                      type="number"
                      v-model="rr.quantity"
                      placeholder="Cantidad"
                      inputClasses="input-group-alternative form-control-sm text-xs"
                      class="m-0"
                      min="1"
                    />
                  </div>
                </div>
              </div>
              <div @click="addRef(tIndex, rIndex)" class="new-button">
                <i class="fa fa-plus"></i>
                Agregar nuevo {{r.reason}}
              </div>
            </div>
          </div>
        </div>

        <div @click="addReason(tIndex)" class="new-button">
          <i class="fa fa-plus"></i>
          Agregar nuevo motivo
        </div>
      </div>

    </div>
    <div @click="addType()" class="new-button">
      <i class="fa fa-plus"></i>
      Agregar nuevo tipo
    </div>
    <hr class="my-3" />
    <div class="d-flex justify-content-end">
      <base-button
        @click="$emit('close')"
        size="sm"
        class="btn btn-danger"
        type="white"
      >
        Cancelar
      </base-button>
      <div v-b-popover.hover.focus.bottom.html="popoverData" tabindex="0">
        <base-button
          @click="saveRequest()"
          size="sm"
          icon="fa fa-check"
          type="success"
          class="btn btn-primary"
          :disabled="!validation.valid || saving"
        >
          Solicitar
        </base-button>
      </div>
    </div>
    <Overlay v-if="saving" class="rounded overflow-hidden">
      <base-loader text="Creando solicitud de muestrario" class="mx-4 flex-grow-1"/>
    </Overlay>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import axios from "axios";
import flatPicker from "vue-flatpickr-component";
import Overlay from "@/components/Overlay.vue";
import BaseLoader from "@/components/BaseLoader.vue";
import { getAuth } from "firebase/auth";
import { doc, getFirestore, serverTimestamp, Timestamp, runTransaction } from "firebase/firestore";
import Formats from "@/mixins/Formats.js";
export default {
  name: "NewSwatchBook",
  mixins: [Formats],
  components: {
    Multiselect,
    flatPicker,
    Overlay,
    BaseLoader,
  },
  data() {
    return {
      user: null,
      form: {
        estimatedDate: null,
        types: [],
      },
      saving: false,
      customers: null,
      types: [
        "PVC ARAUCO / NEOMAT",
        "PVC DURAPLAY",
        "PVC TECNOTABLA",
        "PVC MASISA",
        "PVC CUBRICA",
        "PVC PELIK",
        "PVC FINSA",
        "PVC ESPECIALES",
        "MELAMINA",
        "MELAMINA ARAUCO",
        "MELAMINA DURAPLAY",
        "MELAMINA TECNOTABLA",
        "MELAMINA CUBRICA",
        "MELAMINA FINSA",
        "MADERA NATURAL",
        "METALICOS",
        "METACRILATO",
        "SKO",
        "KRONOSPAN",
        "KASTAMONU",
        "FENIX"
      ],
      reasons: ["Prospecto", "Cliente", "Expo/Viaje", "Otro"],
    };
  },
  methods: {
    refStructure() {
      return {
        ref: null,
        refCode: null,
        refName: null,
        quantity: null,
      };
    },
    reasonStructure() {
      return {
        reason: null,
        refs: [this.refStructure()],
      };
    },
    typeStructure() {
      return {
        type: null,
        reasons: [this.reasonStructure()],
      };
    },
    addRef(typeIndex, reasonIndex){
      this.form.types[typeIndex].reasons[reasonIndex].refs.push(this.refStructure());
    },
    addReason(typeIndex){
      this.form.types[typeIndex].reasons.push(this.reasonStructure());
    },
    addType(){
      this.form.types.push(this.typeStructure());
    },
    removeRef(typeIndex, reasonIndex, refIndex){
      this.form.types[typeIndex].reasons[reasonIndex].refs.splice(refIndex, 1);
    },
    removeReason(typeIndex, reasonIndex){
      this.form.types[typeIndex].reasons.splice(reasonIndex, 1);
    },
    removeType(typeIndex){
      this.form.types.splice(typeIndex, 1);
    },
    filteredReasons(typeIndex) {
      return this.reasons.filter((r) => {
        return this.form.types[typeIndex].reasons.every((fr) => fr.reason !== r);
      });
    },
    saveRequest(){
      if(this.validation.valid){
        this.saving = true;
        const json = JSON.parse(JSON.stringify(this.form)); // copy without reference
        json.types.forEach((t) => {
          t.reasons.forEach((r) => {
            r.refs.forEach((rr) => {
              if(r.reason === "Cliente") {
                rr.refCode = rr.ref.CardCode;
                rr.refName = rr.ref.CardName;
              } else {
                rr.refName = rr.ref;
              }
              rr.quantity = parseInt(rr.quantity);
              this.$delete(rr, "ref");
            });
          });
        });
        json.estimatedDate = Timestamp.fromDate(new Date(`${json.estimatedDate} 00:00:00`));
        json.createdDate = serverTimestamp();
        json.user = this.user.email;
        json.status = "Solicitado";

        console.log("JSON", json);

        const db = getFirestore();
        const collectionName = "swatch_book_requests";
        const counterRef = doc(db, "counters", collectionName);
        
        // Obtener el siguiente ID secuencial usando una transacción
        runTransaction(db, async (transaction) => {
          const counterDoc = await transaction.get(counterRef);
          const nextId = (counterDoc.exists() ? counterDoc.data().lastId : 0) + 1;
          
          // Actualizar el contador
          transaction.set(counterRef, { lastId: nextId });
          
          // Crear el documento con el ID numérico
          const docRef = doc(db, collectionName, String(nextId));
          transaction.set(docRef, json);
          
          return nextId;
        })
          .then((newId) => {
            console.log("newId", newId);
            this.sendEmail(String(newId), json);
          })
          .catch((error) => {
            console.error("Error", error)
            this.$swal("Error", error.message, "error");
            this.saving = false;
          })
      }
    },
    sendEmail(id, form){
      let emailTo;
      if(process.env.NODE_ENV === "production"){
        emailTo = [
          this.user.email, 
          "daliahernandez@canplast.com.mx",
          "federicoflores@canplast.com.mx",
          "bereniceterrazas@canplast.com.mx",
          "muestrarios@canplast.com.mx"
        ];
      } else {
        emailTo = [this.user.email];
      }
      const json = {
        to: emailTo,
        replyTo: this.user.email,
        subject: `Solicitud de muestrario(s) por ${this.user.displayName}`,
        email_body: `
          <b>${this.user.displayName} ha creado una solicitud de muestrario(s) con el ID: ${id}</b>
          <hr>
          <b>Fecha de llegada ideal: </b>${this.form.estimatedDate}
          <br><br>
          <table style="border: 1px solid #8898aa; border-collapse: collapse;">
            <thead>
              <tr>
                <th style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px;">Tipo</th>
                <th style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px;">Motivo</th>
                <th style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px;">Referencia</th>
                <th style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px; text-align: right;">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              ${form.types.map((t) => {
                return t.reasons.map((r) => {
                  return r.refs.map((rr) => {
                    return `
                    <tr>
                      <td style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px;">${t.type}</td>
                      <td style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px;">${r.reason}</td>
                      <td style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px;">${rr.refName}${rr.refCode ? ` (${rr.refCode})` : ''}</td>
                      <td style="border: 1px solid #8898aa; border-collapse: collapse; padding: 6px; text-align: right;">${this.numberFormat(rr.quantity)}</td>
                    </tr>`;
                  }).join("");
                }).join("");
              }).join("")}
            </tbody>
          </table>
          <br>
          Puedes revisar esta solicitud desde la 
          <a href="${this.WEBSITE_URL}/muestrarios#${id}"> Consola de Administración </a>
        `,
      };
      console.log("EMAIL JSON ", json);
      axios
        .post("/api/sg/email/send/general", json)
        .then((res) => {
          console.log("res", res);
          if(res.data.status_code === 202){
            this.$swal("Éxito", `Solicitud enviada correctamente con el id ${id}`, "success");
          }
          else if (res.data.err) {
            console.error("Error", res.data.err);
            this.$swal("Solicitud creada", "Ocurrio un error al enviar el correo" + res.data.err, "warning");
          } else {
            console.error("Error", res.data);
            this.$swal("Solicitud creada", "Ocurrio un error al enviar el correo", "warning");
          }
        })
        .catch((error) => {
          console.error("Error", error);
          this.$swal("Solicitud creada", "Ocurrio un error al enviar el correo" + error, "warning");
        }).
        finally(() => {
          this.saving = false;
          this.$emit("success");
          this.$emit("close");
        });
    
    }
  },
  computed: {
    validation() {
      const complete = {
        "Fecha de llegada ideal": this.form.estimatedDate,
        "Tipo": this.form.types.every((t) => t.type) && this.form.types.length,
        "Motivo": this.form.types.every((t) => t.reasons.every((r) => r.reason)) && this.form.types.length && this.form.types[0].reasons.length,
        "Referencia de Motivo": this.form.types.every((t) =>
          t.reasons.every((r) => r.refs.every((rr) => rr.ref)),
        ) && this.form.types.length && this.form.types[0].reasons.length && this.form.types[0].reasons[0].refs.length,
        "Cantidad": this.form.types.every((t) =>
          t.reasons.every((r) => r.refs.every((rr) => rr.quantity)),
        ) && this.form.types.length && this.form.types[0].reasons.length && this.form.types[0].reasons[0].refs.length,
      };
      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    popoverData() {
      if (!this.validation.missing.length) return null;
      return {
        title: "<small><b>Falta completar los campos:</b></small>",
        content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
      };
    },
    filteredTypes() {
      this
      return this.types.filter((t) => {
        return this.form.types.every((ft) => ft.type !== t);
      });
    }
  },
  created() {
    this.WEBSITE_URL = process.env.VUE_APP_WEBSITE_URL || "https://consola.canplast.net";
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const { email, displayName } = currentUser;
    this.user = { email, displayName };
    this.addType();
    axios
      .get(`/api/customers`)
      .then((res) => {
        this.customers = res.data.value;
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.new-button {
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 500;
  color: #5e72e4 !important;
  font-weight: 600;
  padding: 8px 12px;
  border: 0.375rem;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 0.375rem;
  margin-left: 34px;
}
.new-button:hover {
  background-color: #e6f1ff;
}
.remove-reference,
.remove-reason,
.remove-type {
  cursor: pointer;
  color: #f5365c !important;
  border-radius: 100%;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
}
.reference:hover .remove-reference,
.reason:hover .remove-reason,
.type:hover .remove-type {
  visibility: visible;
}
.remove-reference:hover,
.remove-reason:hover,
.remove-type:hover {
  background-color: #fee2e2;
}
</style>
